const fetixColors = {
  grey: {
    base: "#bdbdbd",
    lighten1: "#dedede",
    lighten2: "#f2f2f2",
    lighten3: "#fafafa",
    darken1: "#757575",
    darken2: "#636363",
    darken3: "#444444",
    darken4: "#222222"
  },
  primary: "#41b6e6",
  "primary-1": "#379cc4",
  blue: "#1d5166",
  lightblue: "#a9dcf1",
  "pink-1": "#ffe5e6",
  "pink-2": "#ffb3b5",
  red: "#ff0032",
  orange: "#ff7733",
  "yellow-1": "#fdda24",
  "light-primary-2": "#96d7f1",
  "accent-blue": "#1d5166",
  error: "#ff0032"
};

export default fetixColors;
